import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventBusService {
  private eventSubject = new Subject<{ name: string; payload?: any }>();

  // Observable for subscribers
  events$ = this.eventSubject.asObservable();

  // Emit events
  emit(eventName: string, payload?: any) {
    this.eventSubject.next({ name: eventName, payload });
  }
}
